import { StaffApi } from 'helpers';

class NotificationService {
  authToken: string;
  notificationService: StaffApi;

  public constructor(authToken: string) {
    this.authToken = authToken;
    this.notificationService = new StaffApi('notifications', authToken);
  }
}

export default NotificationService;
